import type { StaffSettingsSetupChecklist } from "@/containers/staff/staff-settings/staff-settings-form";

export function checklistIncompleteLabels(checklist: StaffSettingsSetupChecklist): string[] {
  const labels: string[] = [];
  if (!checklist.dayBasisConfigured) labels.push("Day basis");
  if (!checklist.professionalTaxConfigured) labels.push("Professional tax");
  if (!checklist.leavePolicyConfigured) labels.push("Leave policy");
  return labels;
}
